// extracted by mini-css-extract-plugin
export default {"wrap":"df0aeabe7840","notice":"b4bdd12d8a5c"};